import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import { Button, Card, Notice } from '@sauda/ui/kit';
import { Screen } from '../app/chrome.js';
import { api } from '../lib/api.js';

/** The fake gateway's "hosted checkout" (development and test only). */
export function DevBillingScreen() {
  const navigate = useNavigate();
  const [message, setMessage] = useState<string | null>(null);
  const send = useMutation({
    mutationFn: (body: { type: string; eventId?: string; minutesAgo?: number }) =>
      api<{ outcome: string }>('/dev/billing/events', { method: 'POST', body }),
    onSuccess: (result) => setMessage(result.outcome),
    onError: () => setMessage('error'),
  });
  const dates = useMutation({
    mutationFn: (body: Record<string, string | null>) =>
      api('/dev/billing/dates', { method: 'POST', body }),
    onSuccess: () => setMessage('dates moved'),
  });
  const ago = (days: number) => new Date(Date.now() - days * 86_400_000).toISOString();
  return (
    <Screen title="Fake payment gateway">
      <Notice tone="info">Development only. Nothing here charges anyone.</Notice>
      {message ? <p data-testid="dev-result">{message}</p> : null}
      <Card>
        <div className="form-stack">
          <div className="chips-row">
            <Button onClick={() => send.mutate({ type: 'payment.succeeded' })}>
              Pay successfully
            </Button>
            <Button variant="tonal" onClick={() => send.mutate({ type: 'payment.failed' })}>
              Payment fails
            </Button>
            <Button variant="text" onClick={() => send.mutate({ type: 'subscription.cancelled' })}>
              Cancel subscription
            </Button>
          </div>
          <div className="chips-row">
            <Button variant="tonal" onClick={() => dates.mutate({ trialEndsAt: ago(1) })}>
              End the trial yesterday
            </Button>
            <Button
              variant="tonal"
              onClick={() =>
                dates.mutate({ trialEndsAt: ago(8), graceEndsAt: ago(1), currentPeriodEnd: ago(8) })
              }
            >
              Make the grace period over
            </Button>
          </div>
          <Button variant="text" onClick={() => void navigate('/billing')}>
            Back to billing
          </Button>
        </div>
      </Card>
    </Screen>
  );
}
